import React from 'react';
import '../styles/background.css';

const TREE_COLOR = '#0a0e0a';

const TREE_ROWS = [
  [-16, [0]],
  [-15, [-1, 0, 1]],
  [-14, [-1, 0, 1]],
  [-13, [-3, -2, -1, 0, 1, 2, 3]],
  [-12, [-3, -2, -1, 0, 1, 2, 3]],
  [-11, [-1, 0, 1]],
  [-10, [-2, -1, 0, 1, 2]],
  [-9,  [-2, -1, 0, 1, 2]],
  [-8,  [-4, -3, -2, -1, 0, 1, 2, 3, 4]],
  [-7,  [-4, -3, -2, -1, 0, 1, 2, 3, 4]],
  [-6,  [-2, -1, 0, 1, 2]],
  [-5,  [-3, -2, -1, 0, 1, 2, 3]],
  [-4,  [-3, -2, -1, 0, 1, 2, 3]],
  [-3,  [-5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5]],
  [-2,  [-5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5]],
  [-1,  [-1, 0, 1]],
  [0,   [-1, 0, 1]],
];

function buildTreeShadow(px) {
  return TREE_ROWS
    .flatMap(([row, cols]) =>
      cols.map(col => `${col * px}px ${row * px}px 0 0 ${TREE_COLOR}`)
    )
    .join(', ');
}

const TREES = [
  { left: '2%',  px: 20, bottom: 0 },
  { left: '10%', px: 28, bottom: 15 },
  { left: '17%', px: 18, bottom: 0 },
  { left: '23%', px: 25, bottom: 10 },
  { left: '30%', px: 22, bottom: 0 },
  { left: '37%', px: 30, bottom: 20 },
  { left: '44%', px: 20, bottom: 0 },
  { left: '51%', px: 27, bottom: 12 },
  { left: '58%', px: 32, bottom: 25 },
  { left: '65%', px: 22, bottom: 0 },
  { left: '72%', px: 28, bottom: 15 },
  { left: '79%', px: 19, bottom: 0 },
  { left: '86%', px: 30, bottom: 10 },
  { left: '93%', px: 24, bottom: 0 },
];

const Background = () => {
  return (
    <>
      <div className="forest-scene">
        <div className="lightning-sky"></div>
        <div className="forest-treeline">
          <div className="forest-ground"></div>
          {TREES.map((tree, i) => (
            <div
              key={i}
              className="pixel-tree"
              style={{
                left: tree.left,
                bottom: `${tree.bottom}px`,
                width: `${tree.px}px`,
                height: `${tree.px}px`,
                boxShadow: buildTreeShadow(tree.px),
              }}
            />
          ))}
        </div>
      </div>
      <div className="background-container">
      </div>
    </>
  );
};

export default Background;
